// extracted by mini-css-extract-plugin
module.exports = {"main":"Shimmer_main__HmC1O","shimmer":"Shimmer_shimmer__Ly2FM"};